/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Container, Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";
// import { BsChevronRight } from "react-icons/bs";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

import "./Points.scss";
import KnowMorwOfPoints from "../../components/Modals/KnowMorwOfPoints";
import BuyPoints from "../../components/Modals/BuyPoints";
import { getUserPoints } from "../../services/points.service";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../utils/action/Action";
import { IoIosInformationCircle } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa6";
import { GoHome } from "react-icons/go";
import { MdOutlineNavigateNext } from "react-icons/md";
import {
  Modal,
  ModalHeader,
  ModalBody,
  // Button,
  // Form,
  // FormGroup,
} from "reactstrap";
import BuyPointsFunctionality from "../BuyPoints/ButPointsFunctionality";
import buy_points_img from "../../assets/buy_points.png";

function Points() {
  const [showKnowMoremodal, setShowKnowMoremodal] = useState(false);
  const [showBuyPointsmodal, setBuyPointsmodal] = useState(false);
  const [userPoints, setUserPoints] = useState();
  const [showModal, setShowModal] = useState(false);
  // const [isPurchaseDisabled, setIsPurchaseDisabled] = useState(false);

  const userName = useSelector(
    (state) => state.userDetailReducer.userData.userName,
  );
  // const [selectedAmount, setSelectedAmount] = useState(null);
  const [buyPointsData, setBuyPointsData] = useState(null);
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const toggleBuyPoints = () => setBuyPointsmodal(!showBuyPointsmodal);
  const toggleKnowMore = () => setShowKnowMoremodal(!showKnowMoremodal);

  const isUserLoggedIn = localStorage.getItem("token");
  const toggleModal = () => setShowModal((prev) => !prev);
  const navigate = useNavigate();

  const getPoints = async () => {
    if (isUserLoggedIn) {
      dispatch(showLoader());
      try {
        const response = await getUserPoints({
          userName: userName,
        });
        if (response && response?.status === 200) {
          setUserPoints(response?.data?.data?.userPoints);
          dispatch(hideLoader());
        }
      } catch (err) {
        setUserPoints(0);
        dispatch(hideLoader());
      }
    }
  };

  useEffect(() => {
    const purchased = localStorage.getItem("creditsPurchased");
    if (purchased === "true") {
      setShowModal(false); // Ensure modal is closed
      setBuyPointsmodal(false);
      localStorage.removeItem("creditsPurchased"); // Clear flag
    } else {
      if (isUserLoggedIn) getPoints();
    }
  }, []);

  // const knowMore = () => {
  //     //setShowKnowMoremodal(true);
  //     // redirect to know more page
  //     window.location.href = "http://nesiya2.jobase.io/explanation-of-points/";
  // }

  const buyPoints = async (amount) => {
    // setSelectedAmount(amount);
    if (isUserLoggedIn) {
      setBuyPointsData({ amount, isUserLoggedIn });
      toggleModal();
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to buy credits?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }

    // navigate('/buyPoints', { state: { data: buy } })
    // setBuyPointsmodal(true)
  };

  return (
    <div className="main_section">
      <Modal
        className="nt-add_points modal-dialog-centered"
        isOpen={showModal}
        toggle={toggleModal}
        style={{ width: "650px" }}
      >
        <ModalHeader>
          <img
            src={buy_points_img}
            alt="buy_points"
            style={{ height: "175px" }}
          />
        </ModalHeader>
        <ModalBody>
          <BuyPointsFunctionality
            data={buyPointsData}
            onClose={toggleModal}
            showBuyPointsmodal={showBuyPointsmodal}
            toggleBuyPoints={toggleBuyPoints}
            setBuyPointsmodal={setBuyPointsmodal}
            getPoints={getPoints}
            // onPurchaseSuccess={() => setIsPurchaseDisabled(true)}
          />
        </ModalBody>
      </Modal>
      <Container>
        <KnowMorwOfPoints
          showKnowMoremodal={showKnowMoremodal}
          toggleKnowMore={toggleKnowMore}
        />
        <BuyPoints
          showBuyPointsmodal={showBuyPointsmodal}
          toggleBuyPoints={toggleBuyPoints}
          isUserLoggedIn={isUserLoggedIn}
          setBuyPointsmodal={setBuyPointsmodal}
        />
        {/* BuyPointsFunctionality */}

        {/* <BuyPointsFunctionality
          data={buyPointsData}
          onClose={toggleModal}
          showBuyPointsmodal={showBuyPointsmodal}
          toggleBuyPoints={toggleBuyPoints}
          setBuyPointsmodal={setBuyPointsmodal}
        /> */}

        {/* <SearchBar /> */}
        <div className="breadcrumb_section">
          <Container>
            <Breadcrumb className="nt-breadcrumb">
              <Link to="/" className="breadcrumb_item1">
                <GoHome className="home_icon" />
              </Link>
              <span className="breadcrumb-divider">
                <MdOutlineNavigateNext />
              </span>
              <BreadcrumbItem active>
                <Link to="/points" className="nt-breadcrumb_item2">
                  My Credits
                </Link>
              </BreadcrumbItem>
            </Breadcrumb>
          </Container>
        </div>
        <div className="points_section">
          <Container fluid>
            <div className="points_box">
              <h4>My Credits </h4>
              <div className="points_block">
                <div className="points_disclaimer">
                  <IoIosInformationCircle size={25} color="#494949" />
                  <p>
                    Payments will be charged to your Google Account at
                    confirmation of purchase.
                  </p>
                </div>
                <section className="wallet_cards">
                  <div className="wallet_cards_container">
                    <p className="wallet_cards_heading">My Wallet</p>
                    <p className="wallet_cards_price">
                      {userPoints
                        ? `$${Number(userPoints).toFixed(2)}`
                        : "$0:00"}
                    </p>
                    <p className="wallet_cards_desc">
                      No Credits! Your wallet is empty. Please add some credits.
                    </p>
                  </div>
                  <div className="wallet_cards_container">
                    <p className="wallet_cards_heading">Add 100 Credits</p>
                    <p className="wallet_cards_price">$20:00</p>
                    <div
                      className={`wallet_cards_button `}
                      onClick={() => buyPoints("20.00")}
                    >
                      <div className="wallet_cards_button_content">
                        <span>Purchase</span>
                        <FaArrowRight />
                      </div>
                    </div>
                  </div>
                  <div className="wallet_cards_container">
                    <p className="wallet_cards_heading">Add 1000 Credits</p>
                    <p className="wallet_cards_price">$100:00</p>
                    <div
                      className={`wallet_cards_button`}
                      onClick={() => buyPoints("100.00")}
                    >
                      <div className="wallet_cards_button_content">
                        <span>Purchase</span>
                        <FaArrowRight />
                      </div>
                    </div>
                  </div>
                </section>
                <section className="wallet_info">
                  <div className="wallet_info_container wallet_info_container_left">
                    <p className="wallet_info_heading">
                      Why do you need Credits?
                    </p>
                    <p className="wallet_info_desc">
                      Nesiya Tova requires you to have credits to optimize your
                      routes in the most efficient order.
                    </p>
                    {/* <div className='wallet_cards_button' style={{width: "120px"}} onClick={knowMore}>
                                            <div className='wallet_cards_button_content'>
                                                <span>Learn More</span>
                                            </div>
                                        </div> */}
                  </div>
                  <div className="wallet_info_container wallet_info_container_right">
                    <p className="wallet_info_heading">
                      Benefits of having Credits
                    </p>
                    <ul>
                      <li>Access premium route optimization.</li>
                      <li>Faster processing of journey plans.</li>
                      <li>Unlock exclusive features and insights.</li>
                    </ul>
                  </div>
                </section>
              </div>
            </div>
          </Container>
        </div>
      </Container>
    </div>
  );
}

export default Points;
